import axios from "axios";
import type {
  SurveyAnswers,
  SurveyMode,
  SurveyStatus,
  SurveyTrigger,
} from "../../common/postTrialSurvey";

const base = "/api/post-trial-survey";

export type SurveyEligibility = {
  eligible: boolean;
  trigger: SurveyTrigger | null;
  mode: SurveyMode;
  agencyName: string | null;
  round: number;
  version: number;
  endsAt: string | null;
  // Where "I'm still evaluating" would push the prompt; null when the
  // officer can't postpone (no running trial).
  postponeUntil: string | null;
  existing: {
    status: SurveyStatus;
    answers: SurveyAnswers;
    quote: string | null;
    dismissedCount: number;
  } | null;
};

export type SurveyResponseBody = {
  answers: SurveyAnswers;
  quote?: string | null;
  platform: "web";
  trigger: SurveyTrigger;
};

export const surveyApi = {
  getEligibility: () =>
    axios.get<SurveyEligibility>(`${base}/eligibility`).then((r) => r.data),
  save: (body: SurveyResponseBody) =>
    axios.put(`${base}/response`, body).then((r) => r.data),
  complete: (body: SurveyResponseBody) =>
    axios.post(`${base}/response/complete`, body).then((r) => r.data),
  postpone: () =>
    axios
      .post<{ postponedUntil: string }>(`${base}/postpone`, { platform: "web" })
      .then((r) => r.data),
};
